import { memoize } from "lodash";
import { IdCoopSettings } from "../constants/IdCoopSettings";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingCoopSettings = function () { return utilBalancing.getBalancing().CoopSettings; };
export var selectCoopFoundCost = memoize(function () {
    var coopSettings = selectBalancingCoopSettings();
    if (coopSettings.has(IdCoopSettings.Standard)) {
        return coopSettings.get(IdCoopSettings.Standard).cost.amount;
    }
    else {
        return 0;
    }
});
export var balancingCoopSettingsMemoizedFunctions = [
    selectBalancingCoopSettings,
    selectCoopFoundCost,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingCoopSettings.ts
// module id = 673
// module chunks = 3